import { Suspense, lazy } from 'react';

import { Loader } from 'shared/ui/Loader';

const SupplierManagement = lazy(() => import('./SupplierManagement'));

export default () => (
  <Suspense fallback={<Loader />}>
    <SupplierManagement />
  </Suspense>
);
